import { Link } from 'react-router-dom'

const LINKS = {
  Catalog: [
    { label: 'All Products',      to: '/catalog' },
    { label: 'Open Marketplace',  to: '/open-marketplace' },
    { label: 'Smart Contracts',   to: '/contracts' },
    { label: 'Bundles',           to: '/bundles' },
    { label: 'Pricing',           to: '/pricing' },
  ],
  Creators: [
    { label: 'Sell Your Code',  to: '/sell' },
    { label: 'Submit Code',     to: '/seller-upload' },
    { label: 'Learn',           to: '/learn' },
  ],
  Legal: [
    { label: 'Terms of Service', to: '/terms' },
    { label: 'Privacy Policy',   to: '/privacy' },
    { label: 'Refund Policy',    to: '/refund' },
  ],
  'S6 Labs': [
    { label: 'Contact', to: '/contact' },
    { label: 'Learn',   to: '/learn' },
  ],
}

export function Footer() {
  return (
    <footer className="border-t border-[#1E1E1E] bg-[#0A0A0A] mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">

          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <div className="w-7 h-7 rounded-lg bg-[#E8850C] flex items-center justify-center flex-shrink-0">
                <span className="text-white text-[10px] font-bold leading-none">S6</span>
              </div>
              <span className="text-[#F5F5F5] font-semibold">SaasFarm</span>
            </Link>
            <p className="text-sm text-[#6B6B6B] leading-relaxed max-w-[200px]">
              Production-ready blockchain applications by S6 Labs.
            </p>
          </div>

          {/* Link groups */}
          {Object.entries(LINKS).map(([group, links]) => (
            <div key={group}>
              <h4 className="text-xs font-semibold text-[#A0A0A0] uppercase tracking-wider mb-3">
                {group}
              </h4>
              <ul className="flex flex-col gap-2">
                {links.map(({ label, to }) => (
                  <li key={label}>
                    <Link
                      to={to}
                      className="text-sm text-[#6B6B6B] hover:text-[#F5F5F5] transition-colors"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-[#1E1E1E] mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#6B6B6B]">
            © 2026 S6 Labs. All rights reserved.
          </p>
          <p className="text-xs text-[#6B6B6B]">
            <span className="text-[#E8850C] font-medium">www.saasfarm.ai</span>
          </p>
        </div>
      </div>
    </footer>
  )
}
